import ShopPremiumFolders from './ShopPremiumFolders';
import ShopPremiumFoldersContainer from './ShopPremiumFolders.container';

export default ShopPremiumFoldersContainer(ShopPremiumFolders);
